import React, { useEffect } from "react";
import styles from "./DataAmination.module.css";
import lottie from "lottie-web";
import listAnimation from "../jsonFile/X4YQnjffiE.json";
const DataAnimation = () => {
  useEffect(() => {
    const container = document.querySelector("#container");
    lottie.loadAnimation({
      container: container,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: listAnimation,
    });
  }, []);
  return (
    <div className={styles.container}>
      <div id="container"></div>
    </div>
  );
};

export default DataAnimation;
